var floatRegex = /\x2D?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)/g;
export { floatRegex };